export const accordionStyle = {
    headerBgColorOpen:"blue",
    headerBgColor:"grey",
    headerColorOpen:"white",
    headerColor:"blue",
    arrowOpenColor:"white",
    arrowClosedColor:"blue",
    arrowSize:"f1",
    headerPadding:"0.75rem 1.25rem",
}